// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay[data-v-53f3f276]{background:var(--background);transition:opacity .3s ease-in-out;opacity:0;pointer-events:none}.overlay[enabled][data-v-53f3f276]:not([enabled=false]){opacity:1;pointer-events:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
